import { Card, Stack } from "@mantine/core";
import type { TilesetSource } from "../types/tileset";
import type { TilesetConfig } from "@project/api";
import type { FC } from "react";

interface LayerListProps {
  sources: TilesetSource[];
  config: TilesetConfig;
}

export const LayerList: FC<LayerListProps> = ({ config }) => {
  return (
    <Stack>
      {Object.entries(config.layers).map(([name, layer]) => (
        <Card key={name} withBorder shadow="sm" radius="md">
          <Stack>
            <Stack>
              Name:
              {" "}
              {name}
            </Stack>
            <Stack>
              Source:
              {" "}
              {/* @ts-expect-error fix later once we support other sources */}
              {layer.sources[0]?.sourceId}
            </Stack>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
